import React, { useState } from 'react';
import { Box, TableBody, TableCell, TableRow } from '@mui/material';
import axios from 'axios';
import { TableCustom } from '../../../components/common';
import useDebounce from '../../../hooks/useDebounce';

const tableHeaderObj = [
  [
    { text: 'S.NO.', rowspan: 1, colspan: 1 },
    { text: 'MACHINE NAME', rowspan: 1, colspan: 1 },
    { text: 'ID NO.', rowspan: 1, colspan: 1 },
  ],
];

const ViewMachineList = ({ moduleId }: { moduleId?: any }) => {
  const [data, setData] = useState<any[]>([]);
  const fetchPartData = () => {
    if (!moduleId) return;
    axios
      .get(`/api/itemMasterRoute/getPartMachineById/${moduleId}`)
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => console.log(err));
  };

  useDebounce(fetchPartData, 300, []);
  return (
    <Box width={600}>
      <TableCustom tableHeaderObj={tableHeaderObj}>
        <TableBody>
          {data &&
            data.map((item: any, index: number) => (
              <React.Fragment key={item?._id}>
                <TableRow>
                  <TableCell align="center">{index + 1}</TableCell>
                  <TableCell align="center">{item?.machine_name}</TableCell>
                  <TableCell align="center">{item?.machine_no}</TableCell>
                </TableRow>
              </React.Fragment>
            ))}
        </TableBody>
      </TableCustom>
    </Box>
  );
};

export default ViewMachineList;
